import { Directive, ElementRef, HostListener, Renderer2 } from "@angular/core";

@Directive({
    selector: '[inputmode="quantity"]'
})
export class QuantityInputDirective {
    element!: any;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {
        let element = this.element = this.elementRef.nativeElement;
        element.setAttribute('inputmode', 'none');

        element.addEventListener('keydown', (e: KeyboardEvent) => {
            if (
                // Allow: these specific keys
                ['Enter', 'Backspace', 'Escape', 'NumpadEnter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', '.', '#'].indexOf(e.key) !== -1 ||
                // Allow: numerals
                !isNaN(Number(e.key)) ||
                // Allow: Ctrl+A
                (e.key === 'a' && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+C
                (e.key === 'c' && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+V
                (e.key === 'v' && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+X
                (e.key === 'x' && (e.ctrlKey || e.metaKey))
            ) {
                // let it happen, don't do anything
                return;
            }

            e.preventDefault();
        })

        element.addEventListener('keyup', (e: any) => {
            let key = e.which || e.keyCode;

            if (key == 16 /* # */) {
                // prevent typing "#" if a decimal is already entered
                if (element.value.indexOf('.') > -1) element.value = element.value.replace("#", "");
            } else {
                // when user has entered a #(digit)
                let str = element.value;
                let match = str.match(/(?<whole>[\d]*)#(?<frac>\d{1})/);
                if (match) {
                    // convert to n/8'th fraction
                    element.value = parseInt(match.groups.whole || 0) + parseFloat(match.groups.frac) / 8;
                    element.dispatchEvent(new Event('input'));
                }
            }
        });
    }
}